import { computed, ref, watch } from "vue";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";
import { TicketsSortingOption } from "@/tickets/utils/tickets-sorting-option-enum";

const checkedFilters = ref<number[]>([]);
const selectedSorting = ref<TicketsSortingOption>(TicketsSortingOption.Default);

const sortedFiltersString = computed(() => {
    return [...checkedFilters.value].sort((a, b) => a - b).join(",");
});

watch(
    checkedFilters,
    (newValue) => {
        if (newValue.length === 0) {
            eventBus.emit(GlobalEvents.TicketFilterInactive);
        } else {
            eventBus.emit(GlobalEvents.TicketFilterActive);
        }
    },
    { deep: true }
);

export function useTicketsFilterHelper() {
    const addFilter = (num: number) => {
        if (checkedFilters.value.includes(num)) return;

        checkedFilters.value.push(num);
    };

    const removeFilter = (num: number) => {
        checkedFilters.value = checkedFilters.value.filter((item) => item !== num);
    };

    return { addFilter, removeFilter };
}

export { checkedFilters, selectedSorting, sortedFiltersString };
